export const newApiMap = {
  APIPreviewWorkItemAIValue: {
    m: 'post',
    u: [
      '/goapi/v5/ai_application_field/preview'
    ]
  },
  APIWorkItemSearch: {
    m: 'post',
    u: [
      '/goapi/v5/project/auth/meego_ai/common/work_item_search'
    ]
  },
  APIAppStoreGetAppDetail: {
    m: 'get',
    u: [
      '/bff/app/center/v1/store/info'
    ],
    q: [
      'project_key',
      'app_key',
      'app_version',
      'language'
    ]
  },
  APIAppStoreGetAppDetailGuest: {
    m: 'get',
    u: [
      '/goapi/v5/app/center/store/info_guest'
    ],
    q: [
      'project_key',
      'app_key',
      'app_version',
      'language'
    ]
  },
  APIGetProductPublic: {
    m: 'get',
    u: [
      '/goapi/v5/commercial/product/public'
    ],
    q: [
      'product_key',
      'lark_product_key'
    ]
  },
  APIProductEntitlement: {
    m: 'get',
    u: [
      '/goapi/v5/commercial/product/tenant_entitlement'
    ],
    q: [
      'product_key'
    ]
  },
  APIGetAIConfigSchema: {
    m: 'post',
    u: [
      '/goapi/v5/workitem/ai_config_schema/get'
    ]
  },
  APIGetAIEntitySchema: {
    m: 'post',
    u: [
      '/goapi/v5/workitem/ai_entity_schema/get'
    ]
  },
  APICreateAIApplication: {
    m: 'post',
    u: [
      '/goapi/v5/ai_application/create'
    ]
  },
  APIUpdateAIApplication: {
    m: 'post',
    u: [
      '/goapi/v5/ai_application/update'
    ]
  },
  APIBatchQueryAIApplication: {
    m: 'post',
    u: [
      '/goapi/v5/ai_application/batch_query'
    ]
  },
  APIBatchDeleteAIApplication: {
    m: 'post',
    u: [
      '/goapi/v5/ai_application/batch_delete'
    ]
  },
  APIAIApplicationPreview: {
    m: 'post',
    u: [
      '/goapi/v5/ai_application/preview'
    ]
  },
  ApiUpdateFieldV5New: {
    m: 'post',
    u: [
      '/goapi/v5/settings/update_field_new'
    ]
  },
  ApiQueryFieldByPKeyAndWITKey: {
    m: 'get',
    u: [
      '/goapi/v3/settings/:project_key/:work_item_type_key/fields'
    ],
    q: [
      'current_project_key',
      'skip_assembly_option',
      'prune_option_fields',
      'include_create_page_fields_only',
      'resource_class'
    ]
  },
  ApiQueryFieldByPKeyAndWITKeyAndFKeys: {
    m: 'post',
    u: [
      '/goapi/v3/settings/:project_key/:work_item_type_key/fields/keys'
    ]
  },
  APIExecutePatchTransactionV2: {
    m: 'post',
    u: [
      '/goapi/v2/projects/:project_key/patchV2'
    ]
  },
  APIQueryTemplateDetailByUUID: {
    m: 'post',
    u: [
      '/goapi/v1/projects/:project_key/templates/detail'
    ]
  },
  APIEditTemplate: {
    m: 'put',
    u: [
      '/goapi/v1/projects/:project_key/templates/:template_id'
    ]
  },
  APIIsTemplateNameDuplicated: {
    m: 'get',
    u: [
      '/goapi/v1/projects/:project_key/templates/work_item_type/:work_item_type/check/name'
    ],
    q: [
      'name'
    ]
  },
  APIGetWorkItemTypeInfoByPKAndWITK: {
    m: 'post',
    u: [
      '/goapi/v5/projects/work_item_types/'
    ]
  },
  APIFetchAllWorkItemRelationByProjectKeyWithBizType: {
    m: 'get',
    u: [
      '/goapi/v5/settings/work_item_relation/filter_by_type'
    ],
    q: [
      'project_key',
      'work_item_type_key',
      'target_biz_type_key'
    ]
  },
  APIGetWorkItemTypeInfoV2: {
    m: 'get',
    u: [
      '/goapi/v2/projects/:project_key/work_item_types'
    ],
    q: [
      'need_virtual',
      'need_manage_permission',
      'need_perm_config_permission'
    ]
  },
  APIFetchAllWorkItemRelationByProjectKey: {
    m: 'get',
    u: [
      '/goapi/v1/settings/:project_key/work_item_relation'
    ]
  },
  APIQueryTemplateBasicInfosByProjectKeyAndWorkItemTypeKey: {
    m: 'get',
    u: [
      '/goapi/v1/projects/:project_key/templates/basic'
    ],
    q: [
      'work_item_type',
      'skip_shard_project_key',
      'permission_filter',
      'with_stage_manage'
    ]
  },
  APIQueryTemplateDetailByUUIDAndVersion: {
    m: 'get',
    u: [
      '/goapi/v2/projects/:project_key/templates/version'
    ],
    q: [
      'template_uuid',
      'version'
    ]
  },
  APICreateAIApplicationGroup: {
    m: 'post',
    u: [
      '/goapi/v5/ai_application_group/create'
    ]
  },
  APIUpdateAIApplicationGroup: {
    m: 'put',
    u: [
      '/goapi/v5/ai_application_group/update'
    ]
  },
  APIListAIApplicationGroup: {
    m: 'get',
    u: [
      '/goapi/v5/ai_application_group/list'
    ],
    q: [
      'page',
      'page_size',
      'madmin_ai_application_group_name',
      'name'
    ]
  },
  APIWorkItemAIValueProgress: {
    m: 'post',
    u: [
      '/goapi/v5/ai_application_field/progress'
    ]
  },
  APIQueryAIApplicationGlobalConfig: {
    m: 'get',
    u: [
      '/goapi/v5/ai_application/query_global_config'
    ]
  }
};
